import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { provide } from 'vue'
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { DefaultApolloClient } from '@vue/apollo-composable'

// HTTP connection to the API

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: 'https://asia-northeast1-kanji-site-7f0d4.cloudfunctions.net/graphql',
})

// Cache implementation
const cache = new InMemoryCache({
  addTypename: false,
})

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
})

provide(DefaultApolloClient, apolloClient)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})